import { createAction, props } from '@ngrx/store';
export const setAIEventSummary = createAction('[Fund Chart] Set AI Event Summary Keys', props());
export const deleteAIEventSummary = createAction('[Fund Chart] Delete AI Event Summary Keys', props());
